/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de almacenes exhibidores.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmAlmacenesExhibidores from "../../../catalogos/almacenesexhibidores/FrmAlmacenesExhibidores.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmAlmacenesExhibidoresPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmAlmacenesExhibidores">
      <FrmAlmacenesExhibidores />
    </SizeSoftXFrmPortatil>
  );
}
